// @flow
import React, { Component } from "react";

class IconBed extends Component<{}> {
  render() {
    return (
      <svg
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        height="80"
        viewBox="0 0 49 50"
      >
        <g transform="matrix(.77025 0 0 .77025 1.135 10.181)">
          <g>
            <g>
              <g>
                <g>
                  <path fill="#3F3F3F" d="M0 37.971h1.512V.507H0v37.464z"></path>
                  <path
                    fill="#3F3F3F"
                    d="M59.155 37.971h1.513V12.162h-1.513v25.809z"
                  ></path>
                  <g transform="translate(0 11.478)">
                    <path
                      fill="#3F3F3F"
                      d="M1.512 7.25h13.756c1.95 0 3.598-1.28 3.598-2.796 0-1.515-1.648-2.795-3.598-2.795H1.512V7.25zm13.756 1.52H0V.139h15.268c2.818 0 5.111 1.936 5.111 4.315 0 2.38-2.293 4.316-5.111 4.316z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      d="M1.512 15.576h21.687V8.77H1.512v6.806zM0 17.096h24.712V7.25H0v9.846z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      d="M24.712 15.576h34.443V8.77H24.712v6.806zm-1.513 1.52h37.469V7.25H23.199v9.846z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      className="custom-fill"
                      d="M24.712 15.576h34.443V8.77H24.712v6.806z"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconStethoscope extends Component<{}> {
  render() {
    return (
      <svg
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 49 50"
      >
        <g transform="matrix(.88355 0 0 .88355 8.721 1.2)">
          <g>
            <g>
              <g>
                <g>
                  <path
                    fill="#3F3F3F"
                    d="M27.722 52.478c-3.645 0-6.61-2.99-6.61-6.666v-6.668h6.61c3.645 0 6.61 2.991 6.61 6.668 0 3.676-2.965 6.666-6.61 6.666m0-14.73h-6.61v-6.269c7.028-.365 12.635-6.246 12.635-13.424V6.883a4.414 4.414 0 00-4.385-4.423v1.397a3.023 3.023 0 013 3.026v11.172c0 6.642-5.357 12.045-11.942 12.045S8.478 24.697 8.478 18.055V6.883a3.024 3.024 0 013-3.026V2.46a4.413 4.413 0 00-4.385 4.423v11.172c0 7.178 5.606 13.059 12.635 13.424v6.269h-5.224c.014.184.028.369.028.557 0 .285-.02.563-.051.839h5.247v6.668c0 4.445 3.586 8.063 7.994 8.063 4.409 0 7.995-3.618 7.995-8.063 0-4.447-3.586-8.064-7.995-8.064"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    className="custom-fill"
                    d="M14.041 3.158c0-.806-.81-1.506-1.871-1.705v3.411c1.061-.199 1.871-.899 1.871-1.706"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    d="M12.17 1.453c1.061.199 1.871.899 1.871 1.706 0 .806-.81 1.506-1.871 1.705V1.453zm-.692 2.404c-.239 0-.47.031-.693.084v1.674c0 .371.327.678.693.699l.082.003c2.132 0 3.866-1.417 3.866-3.158C15.426 1.417 13.692 0 11.56 0l-.088.003a.697.697 0 00-.687.699v1.819c.226-.036.456-.061.693-.061v1.397z"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    className="custom-fill"
                    d="M26.787 3.158c0 .806.81 1.507 1.871 1.706v-3.41c-1.063.199-1.871.899-1.871 1.704"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    d="M28.658 4.864c-1.061-.199-1.871-.9-1.871-1.706 0-.805.808-1.505 1.871-1.705v3.411zm.704-2.404c.232 0 .458.024.68.059V.702c0-.371-.325-.679-.692-.699A2.246 2.246 0 0029.268 0c-2.131 0-3.865 1.417-3.865 3.158 0 1.742 1.734 3.159 3.865 3.159l.088-.004a.694.694 0 00.686-.698V3.938a2.985 2.985 0 00-.68-.082V2.46z"
                  ></path>
                  <path
                    fill="#FF5A5F"
                    className="custom-fill"
                    d="M7.266 41.095c-1.525 0-2.766-1.251-2.766-2.79 0-1.538 1.241-2.79 2.766-2.79s2.766 1.252 2.766 2.79c0 1.539-1.241 2.79-2.766 2.79m0-8.722c-3.243 0-5.881 2.661-5.881 5.932 0 3.271 2.638 5.932 5.881 5.932 3.243 0 5.881-2.661 5.881-5.932 0-3.271-2.638-5.932-5.881-5.932"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    d="M7.266 44.237c-3.243 0-5.881-2.661-5.881-5.932 0-3.271 2.638-5.932 5.881-5.932 3.243 0 5.881 2.661 5.881 5.932 0 3.271-2.638 5.932-5.881 5.932m7.238-6.489c-.284-3.781-3.418-6.772-7.238-6.772C3.259 30.976 0 34.264 0 38.305s3.259 7.329 7.266 7.329c3.725 0 6.8-2.843 7.215-6.49a7.5 7.5 0 00.051-.839c0-.188-.014-.372-.028-.557"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    d="M7.266 39.698a1.389 1.389 0 01-1.381-1.393c0-.769.62-1.393 1.381-1.393.762 0 1.381.624 1.381 1.393 0 .768-.619 1.393-1.381 1.393m0-4.183c-1.525 0-2.766 1.252-2.766 2.79 0 1.539 1.241 2.79 2.766 2.79s2.766-1.251 2.766-2.79c0-1.538-1.241-2.79-2.766-2.79"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}


class IconMedicalFolder extends Component<{}> {
  render() {
    return (
      <svg
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 49 50"
      >
        <g transform="translate(6.513 1.483) scale(.92357)">
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        fill="#3F3F3F"
                        d="M37.637 49.256H1.314V6.54h2.101v40.414h25.432l.193-.192 3.152-3.137 3.346-3.328V6.54h2.099v42.716zm-4.343-8.575l-4.062 4.04v-4.04h4.062zM4.73 6.54h5.819v2.531h17.854V6.54h5.82v32.833h-5.648a.656.656 0 00-.658.654v5.619H4.73V6.54zm7.134-1.79h5.911V2.671c0-.552.451-1.001 1.006-1.001h1.294c.555 0 1.006.449 1.006 1.001V4.75h6.008v3.013H11.864V4.75zm27.088.483H28.403V3.442h-6.007v-.771A2.317 2.317 0 0020.075.363h-1.294a2.317 2.317 0 00-2.321 2.308v.771h-5.911v1.791H0v45.331h38.952V5.233z"
                      ></path>
                    </g>
                    <path
                      fill="#3F3F3F"
                      className="custom-fill"
                      d="M33.294 40.681h-4.062v4.04l4.062-4.04z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      d="M8.532 14.889h21.889v-1.307H8.532v1.307z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      d="M8.532 19.102h21.889v-1.308H8.532v1.308z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      d="M8.532 23.314h21.889v-1.308H8.532v1.308z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      d="M8.532 27.525h21.889v-1.308H8.532v1.308z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      d="M8.532 31.736h21.889v-1.307H8.532v1.307z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      d="M8.532 35.948h13.704V34.64H8.532v1.308z"
                    ></path>
                    <path
                      fill="#3F3F3F"
                      className="custom-fill"
                      d="M27.089 4.75h-6.008V2.671c0-.552-.452-1-1.006-1h-1.294c-.555 0-1.006.448-1.006 1V4.75h-5.911v3.013h15.225V4.75z"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>)
  }
}


class IconDrug extends Component<{}> {
  render() {
    return (
      <svg

        viewBox="0 0 49 50"
      >
        <defs>
          <path
            id="path-1"
            d="M0.000177777778 0.341775L24.6486222 0.341775 24.6486222 20.5625 0.000177777778 20.5625z"
          ></path>
        </defs>
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(-48 -878)">
            <g transform="translate(18 631)">
              <g transform="translate(30 247)">
                <g transform="rotate(-47 40.368 17.552)">
                  <g transform="translate(0 .096)">
                    <mask id="mask-2" fill="#fff">
                      <use xlinkHref="#path-1"></use>
                    </mask>
                    <path
                      fill="#3F3F3F"
                      d="M10.27 1.654c-4.927 0-8.936 3.947-8.936 8.798s4.009 8.798 8.937 8.798h13.044V1.654H10.271zM24.65 20.563H10.27C4.607 20.563 0 16.027 0 10.452 0 4.877 4.606.342 10.27.342h14.378v20.22z"
                      mask="url(#mask-2)"
                    ></path>
                  </g>
                  <path
                    fill="#3F3F3F"
                    d="M14.0364444 5.23285L17.6595556 5.23285 17.6595556 3.92035 14.0364444 3.92035z"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    d="M4.872 10.548H3.538c0-3.655 3.02-6.627 6.733-6.627h1.828v1.312h-1.828c-2.977 0-5.4 2.384-5.4 5.315"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    className="custom-fill"
                    d="M37.693 1.094H23.982v18.908h13.71c5.305 0 9.604-4.233 9.604-9.454 0-5.221-4.3-9.454-9.603-9.454"
                  ></path>
                  <path
                    fill="#3F3F3F"
                    d="M24.648 19.346h13.045c4.928 0 8.937-3.947 8.937-8.798S42.62 1.75 37.693 1.75H24.648v17.596zm13.045 1.312H23.315V.438h14.378c5.663 0 10.27 4.535 10.27 10.11 0 5.575-4.607 10.11-10.27 10.11z"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>)
  }
}


class IconNurse extends Component<{}> {
  render() {
    return (
      <svg
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 49 50"
      >
        <g transform="matrix(.8686 0 0 .8686 9.853 2.484)">
          <g>
            <g>
              <g>
                <path
                  fill="#3F3F3F"
                  className="custom-fill"
                  d="M26 12.277l-.172 4.04-1.67-.317-3.361-1.703-.849-2.02H26z"
                ></path>
                <path
                  fill="#3F3F3F"
                  className="custom-fill"
                  d="M19.073 12.417c.072 1.414-.402 2.275-1.423 2.583a824.02 824.02 0 01-6.295 1.846H7.469l.686-4.964 10.918.535z"
                ></path>
                <path
                  fill="#3F3F3F"
                  d="M16.831 1.281c6.004-.03 9.16 1.092 9.443 1.67.018.037.038.07.061.102l.04 8.328-8.573.042-10.093.049-.325.002-.039-8.328a.699.699 0 00.061-.103c.276-.581 3.418-1.733 9.425-1.762zm8.55 14.595c-1.192-.204-3.626-.879-4.906-3.066-.017-.031-.04-.057-.061-.084l-.007-.035 4.974-.024v3.209zm-8.518 12.525c-4.697 0-8.518-3.254-8.518-7.253V17.56c.158.013.531.037 1.059.037 2.169 0 6.957-.41 10.247-3.721 1.678 2.448 4.473 3.119 5.73 3.3v3.972c0 3.999-3.822 7.253-8.518 7.253zm2.153-15.703c-3.829 4.166-10.558 3.587-10.626 3.581-.016-.002-.03 0-.045 0V12.75l10.671-.052zm-12.121.059l.185-.001v8.392c0 4.706 4.388 8.534 9.783 8.534 5.394 0 9.783-3.828 9.783-8.534v-4.352a.666.666 0 00.031-.168.652.652 0 00-.031-.222v-3.745l.228-.001c.425-.002.77-.336.769-.745L27.6 2.763a.73.73 0 00-.331-.605C25.977.428 20.176-.016 16.825.001 13.476.017 7.678.517 6.403 2.26a.727.727 0 00-.324.607l.043 9.153a.732.732 0 00.311.592.799.799 0 00.462.145z"
                ></path>
                <path
                  fill="#3F3F3F"
                  d="M13.654 6.909h2.576v2.609c0 .353.283.64.632.64.35 0 .633-.287.633-.64V6.909h2.577a.636.636 0 00.632-.64.637.637 0 00-.632-.641h-2.577V3.019a.636.636 0 00-.633-.64.636.636 0 00-.632.64v2.609h-2.576a.637.637 0 00-.632.641c0 .353.283.64.632.64"
                ></path>
                <g transform="translate(0 30.764)">
                  <path
                    fill="#3F3F3F"
                    d="M20.015.533h-6.304C6.151.533 0 6.761 0 14.418v6.023c0 .353.283.64.632.64.35 0 .633-.287.633-.64v-6.023c0-6.95 5.583-12.605 12.446-12.605h6.304c6.863 0 12.446 5.655 12.446 12.605v6.023c0 .353.283.64.632.64.35 0 .633-.287.633-.64v-6.023c0-7.657-6.151-13.885-13.711-13.885"
                  ></path>
                </g>
                <g transform="translate(6.939 45.52)">
                  <path
                    fill="#3F3F3F"
                    d="M.773.002a.636.636 0 00-.633.64v5.042c0 .354.283.64.633.64a.636.636 0 00.632-.64V.642a.636.636 0 00-.632-.64"
                  ></path>
                </g>
                <g transform="translate(24.98 45.52)">
                  <path
                    fill="#3F3F3F"
                    d="M1.034.002a.636.636 0 00-.632.64v5.042c0 .354.283.64.632.64.35 0 .632-.286.632-.64V.642a.635.635 0 00-.632-.64"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>)
  }
}

class IconHospital extends Component<{}> {
  render() {
    return (
      <svg
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 49 50"
      >
        <g transform="matrix(.76518 0 0 .76518 .797 7.451)">
          <g>
            <g>
              <g>
                <path className="custom-fill" d="M6 13H20V43H6z"></path>
                <path className="custom-fill" d="M42 14H56V44H42z"></path>
                <path fill="#fff" d="M20 0H42V45H20z"></path>
                <g fill="#4A4A4A">
                  <path d="M53.306 17.051h-8.614a.657.657 0 100 1.311h8.614a.657.657 0 00.657-.655.657.657 0 00-.657-.656"></path>
                  <path d="M53.306 21.159h-8.614a.656.656 0 100 1.31h8.614a.656.656 0 00.657-.655.656.656 0 00-.657-.655"></path>
                  <path d="M53.306 25.266h-8.614a.656.656 0 100 1.31h8.614a.656.656 0 100-1.31"></path>
                  <path d="M53.306 29.373h-8.614a.657.657 0 100 1.311h8.614a.657.657 0 00.657-.655.657.657 0 00-.657-.656"></path>
                  <path d="M53.306 33.481h-8.614a.656.656 0 100 1.31h8.614a.656.656 0 00.657-.655.656.656 0 00-.657-.655"></path>
                  <path d="M53.306 37.588h-8.614a.656.656 0 100 1.31h8.614a.656.656 0 100-1.31"></path>
                  <path d="M8.612 18.362h8.614a.657.657 0 00.658-.656.656.656 0 00-.658-.654H8.612a.655.655 0 100 1.31"></path>
                  <path d="M17.226 21.159H8.613a.655.655 0 100 1.31h8.613a.656.656 0 100-1.31"></path>
                  <path d="M17.226 25.266H8.613a.655.655 0 100 1.31h8.613a.656.656 0 100-1.31"></path>
                  <path d="M17.226 29.373H8.613a.656.656 0 100 1.311h8.613a.657.657 0 100-1.311"></path>
                  <path d="M17.226 33.481H8.613a.655.655 0 100 1.31h8.613a.656.656 0 100-1.31"></path>
                  <path d="M17.226 37.588H8.613a.655.655 0 100 1.31h8.613a.656.656 0 100-1.31"></path>
                  <path d="M32.416 12.887h-2.879a.656.656 0 100 1.31h2.879a.656.656 0 100-1.31"></path>
                  <path d="M32.416 24.525h-2.879a.656.656 0 100 1.31h2.879a.656.656 0 100-1.31"></path>
                  <path d="M32.416 18.706h-2.879a.656.656 0 100 1.31h2.879a.656.656 0 100-1.31"></path>
                  <path d="M32.416 30.343h-2.879a.656.656 0 100 1.311h2.879a.657.657 0 100-1.311"></path>
                  <path d="M23.505 14.197h2.879a.656.656 0 100-1.31h-2.879a.657.657 0 00-.658.655c0 .362.295.655.658.655"></path>
                  <path d="M23.505 25.835h2.879a.656.656 0 000-1.311h-2.879a.657.657 0 00-.658.655c0 .362.295.656.658.656"></path>
                  <path d="M23.505 20.016h2.879a.656.656 0 100-1.31h-2.879a.656.656 0 00-.658.654c0 .363.295.656.658.656"></path>
                  <path d="M23.505 31.653h2.879a.656.656 0 100-1.31h-2.879a.657.657 0 00-.658.655c0 .362.295.655.658.655"></path>
                  <path d="M23.505 37.489h2.879a.656.656 0 100-1.31h-2.879a.657.657 0 00-.658.655c0 .362.295.655.658.655"></path>
                  <path d="M35.569 14.197h2.879a.656.656 0 100-1.31h-2.879a.656.656 0 100 1.31"></path>
                  <path d="M35.569 25.835h2.879a.657.657 0 100-1.311h-2.879a.656.656 0 100 1.311"></path>
                  <path d="M35.569 20.016h2.879a.656.656 0 100-1.31h-2.879a.656.656 0 100 1.31"></path>
                  <path d="M35.569 31.653h2.879a.656.656 0 100-1.31h-2.879a.656.656 0 100 1.31"></path>
                  <path d="M35.569 37.489h2.879a.656.656 0 100-1.31h-2.879a.656.656 0 100 1.31"></path>
                  <path d="M27.98 7.16h2.339v2.332c0 .362.294.655.657.655a.656.656 0 00.657-.655V7.16h2.34a.656.656 0 00.657-.655.656.656 0 00-.657-.655h-2.34V3.518a.657.657 0 00-1.314 0V5.85H27.98a.656.656 0 100 1.31"></path>
                  <path d="M42.67 43.042h12.651v-28.69H42.67v28.69zm-1.314 1.516h-7.662v-9.46a.656.656 0 00-.657-.654h-4.122a.656.656 0 00-.657.654v9.46h-7.662V1.31h20.76v43.248zm-11.783.001h2.807v-8.805h-2.807v8.805zM6.631 43.042h12.651v-28.69H6.631v28.69zm50.005.022V13.697a.657.657 0 00-.658-.656H42.67V.655A.656.656 0 0042.013 0H19.939a.656.656 0 00-.657.655v12.386H5.974a.657.657 0 00-.657.656v29.367H.657a.657.657 0 100 1.311h5.368a.614.614 0 00.161-.023h13.096v.861c0 .362.294.655.657.655h22.074a.656.656 0 00.657-.655v-.861h13.097a.602.602 0 00.161.023h5.367a.657.657 0 00.658-.655.657.657 0 00-.658-.656h-4.659z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconLentils extends Component<{}> {
  render() {
    return (
      <svg
        viewBox="0 0 52 36"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(-45 -1270)">
            <g transform="translate(18 1021)">
              <g transform="translate(27 249)">
                <g>
                  <circle cx="19" cy="11" r="10" className="custom-fill" fill="#FF5A5F"></circle>
                  <path
                    fill="#4A4A4A"

                    d="M38.838 17.112c0 7.209-5.732 13.074-12.777 13.074-5.474 0-10.14-3.547-11.957-8.507.996.511 2.073.871 3.21 1.06 1.822 2.833 4.948 4.71 8.513 4.71 5.636 0 10.203-4.673 10.203-10.439 0-4.43-2.705-8.199-6.513-9.713-.149-.391-.316-.773-.504-1.142 1.796.146 3.51.427 5.139.844 2.978 2.496 4.686 6.17 4.686 10.113M9.885 11.45c0-.325.017-.647.048-.964a25.096 25.096 0 014.171-2.219 15.219 15.219 0 00-2.778 8.224 9.525 9.525 0 01-1.44-5.041M19.1 2.02c2.145 0 4.116.76 5.684 2.022-2.695.088-5.13.452-7.319 1.014a.964.964 0 00-.376.102 28.475 28.475 0 00-6.476 2.62c1.402-3.38 4.679-5.758 8.487-5.758m9.216 9.429c0 5.2-4.134 9.429-9.216 9.429a9.031 9.031 0 01-5.69-2.027 13.292 13.292 0 01-.126-1.739c0-3.96 1.719-7.643 4.718-10.14 2.498-.624 5.182-.938 8.042-.938.201 0 .397.008.596.011a9.519 9.519 0 011.676 5.404m23.265 7.127c-.06-.151-1.51-3.74-5.4-7.336-2.368-2.189-5.988-4.65-11.126-6.061a.976.976 0 00-.349-.098c-2.104-.55-4.458-.921-7.08-1.03C25.572 1.578 22.514 0 19.1 0 13.628 0 9.068 4.044 8.106 9.362 2.336 13.472.12 18.465.083 18.55c-.218.511.009 1.105.508 1.329a.98.98 0 001.3-.517c.015-.034 1.488-3.384 5.187-6.68.28-.25.568-.492.857-.727a11.517 11.517 0 003.628 7.932c1.278 7.001 7.29 12.319 14.498 12.319 8.134 0 14.752-6.771 14.752-15.094 0-3.2-.974-6.248-2.747-8.778a23.897 23.897 0 016.716 4.336c3.59 3.29 4.957 6.633 4.97 6.665a.988.988 0 00.916.63.96.96 0 00.37-.074c.505-.21.749-.799.543-1.315"
                  ></path>
                </g>
                <g fill="#4A4A4A" transform="translate(0 20)">
                  <path d="M34.574 12.549c-2.803.823-5.867 1.241-9.107 1.241C7.402 13.79 2.107 1.16 1.892.624A.976.976 0 00.613.074C.111.28-.13.863.073 1.374c.059.15 1.5 3.702 5.37 7.262 3.546 3.263 9.899 7.153 20.024 7.153 3.423 0 6.671-.444 9.651-1.32.521-.153.822-.707.671-1.238a.98.98 0 00-1.215-.683"></path>
                </g>
                <path
                  fill="#4A4A4A"
                  d="M49.61 24.214a.946.946 0 00-1.383.203A24.9 24.9 0 0139.55 32c-.489.258-.69.89-.45 1.413a.983.983 0 00.887.588.94.94 0 00.435-.108 26.933 26.933 0 009.377-8.2c.329-.465.244-1.126-.19-1.478"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconGlasses extends Component<{}> {
  render() {
    return (
      <svg
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 57 40"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="#4A4A4A" transform="translate(-43 -1105)">
            <g transform="translate(18 1021)">
              <g transform="translate(25 84)">
                <path d="M44.725 38.532c-5.559-.007-10.177-4.334-10.603-9.935a1.45 1.45 0 001.745-1.09 1.467 1.467 0 00-1.077-1.763 1.44 1.44 0 00-.504-.03c1.138-5.827 6.734-9.618 12.5-8.468 3.745.747 6.808 3.466 8.025 7.124.148.438.265.885.353 1.34a1.464 1.464 0 00-1.373 1.46 1.456 1.456 0 001.446 1.466h.004c.03.001.058 0 .087-.005-.446 5.587-5.058 9.893-10.603 9.9m-32.637 0c-5.545-.007-10.157-4.313-10.603-9.9a.508.508 0 00.087.005c.8.001 1.45-.653 1.45-1.462v-.004a1.464 1.464 0 00-1.372-1.46c.087-.455.205-.902.352-1.34 1.864-5.63 7.89-8.668 13.461-6.784 3.63 1.227 6.329 4.331 7.064 8.128A1.454 1.454 0 0020.917 27a1.463 1.463 0 001.272 1.627c.168.02.338.01.503-.029-.427 5.601-5.045 9.928-10.604 9.935m38.347-21.516l-8.36-14.054c-.348-.567-2.185-3.377-4.022-2.844-1.49.43-2.152 2.639-2.152 7.159a.73.73 0 00.724.734c.4 0 .726-.327.726-.732v-.002c0-5.282.987-5.717 1.103-5.752.493-.141 1.673 1.051 2.384 2.2l7.344 12.348c-6.295-1.894-12.936 1.635-14.96 7.95v.002c-1.783-2.688-5.384-3.406-8.044-1.604a5.83 5.83 0 00-1.587 1.604v-.002c-2.024-6.315-8.664-9.844-14.96-7.95l7.335-12.339c.72-1.163 1.895-2.35 2.393-2.209.116.035 1.103.47 1.103 5.752a.73.73 0 00.724.734c.4 0 .726-.327.726-.731v-.003c0-4.52-.662-6.729-2.151-7.159-1.838-.533-3.675 2.277-4.033 2.854l-8.35 14.044C.495 20.204-1.717 27.608 1.437 33.554 4.59 39.5 11.917 41.736 17.8 38.548c3.926-2.127 6.376-6.265 6.376-10.767 0-.403-.02-.805-.062-1.206.392-2.396 2.631-4.018 5.002-3.622a4.374 4.374 0 013.583 3.622c-.042.4-.063.803-.062 1.206 0 6.747 5.41 12.218 12.086 12.219 6.676.001 12.088-5.467 12.09-12.214 0-4.504-2.45-8.643-6.378-10.77"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}


class IconRimlessGlasses extends Component<{}> {
  render() {
    return (
      <svg

        viewBox="0 0 67 23"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(-38 -1199)">
            <g transform="translate(18 1021)">
              <g transform="translate(20 178)">
                <path
                  fill="#FF5A5F"
                  className="custom-fill"
                  d="M2 1.303h26.2c1.512 2.574 2.016 5.005 1.512 7.292-.757 3.432-6.588 12.328-10.969 12.328-2.92 0-6.168-.292-9.743-.875L6.512 18.21 1.57 11.656V5.13L2 1.68"
                ></path>
                <path
                  fill="#FF5A5F"
                  className="custom-fill"
                  d="M36.015 1.303H63.14c1.566 2.574 2.088 5.005 1.566 7.292-.783 3.432-6.82 12.328-11.355 12.328-3.024 0-6.386-.292-10.088-.875l-2.575-1.839-5.118-6.553V5.13l.446-3.452"
                  transform="matrix(-1 0 0 1 100.47 0)"
                ></path>
                <g fill="#4A4A4A" transform="translate(5 5.833)">
                  <path d="M1.494 5.257A.874.874 0 10.257 6.494l5.25 5.25a.873.873 0 001.236 0 .874.874 0 000-1.238l-5.25-5.25z"></path>
                  <path d="M1.494.257A.874.874 0 10.257 1.494l5.25 5.25a.873.873 0 001.236 0 .874.874 0 000-1.238L1.493.256z"></path>
                  <path d="M9.29 8.221A.754.754 0 108.22 9.29l1.49 1.49a.753.753 0 001.068 0 .754.754 0 000-1.068l-1.49-1.49z"></path>
                </g>
                <g fill="#4A4A4A">
                  <g>
                    <path d="M15.262 20.536c-7.505 0-13.612-6.08-13.612-13.554 0-1.791.355-3.539 1.054-5.202H27.82a13.33 13.33 0 011.054 5.202c0 7.473-6.106 13.554-13.612 13.554m15.21-14.542a15.016 15.016 0 00-1.365-5.38.824.824 0 00-.749-.477H2.168a.826.826 0 00-.75.477A14.981 14.981 0 000 6.982c0 8.38 6.847 15.196 15.262 15.196 8.126 0 14.769-6.359 15.22-14.338"></path>
                  </g>
                  <g transform="translate(34.65)">
                    <path d="M15.91 20.536c-7.506 0-13.612-6.08-13.612-13.554 0-1.79.354-3.537 1.055-5.202h25.115a13.33 13.33 0 011.054 5.202c0 7.473-6.106 13.554-13.612 13.554M.686 7.72c.39 8.036 7.06 14.458 15.225 14.458 8.416 0 15.263-6.817 15.263-15.196-.001-2.201-.478-4.344-1.42-6.368a.824.824 0 00-.748-.477H2.815a.825.825 0 00-.748.477 15.021 15.021 0 00-1.362 5.32"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconOrthodontics extends Component<{}> {
  render() {
    return (<svg


      viewBox="0 0 59 38"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-41 -1662)">
          <g transform="translate(18 1411)">
            <g transform="translate(23 251)">
              <rect
                width="8"
                height="6"
                x="40"
                y="10"
                rx="2"
                fill="#FF5A5F"
                className="custom-fill"
              ></rect>
              <rect
                width="8"
                height="6"
                x="11"
                y="10"
                rx="2"
                fill="#FF5A5F"
                className="custom-fill"
              ></rect>
              <path
                fill="#4A4A4A"
                fillRule="nonzero"
                d="M58.124 4.748c-.616-1.791-1.981-3.037-4.056-3.701-5.322-1.705-8.51.38-10.322 2.675-.67-.845-1.545-1.675-2.67-2.294-2.157-1.186-4.731-1.313-7.65-.376-1.948.623-3.26 1.765-3.925 3.384-.664-1.621-1.978-2.765-3.927-3.389-5.322-1.705-8.51.38-10.322 2.675-.67-.845-1.545-1.675-2.67-2.294C10.425.242 7.85.115 4.932 1.052c-2.076.664-3.44 1.91-4.056 3.701C-.821 9.681 3.773 17.13 4.56 18.352c-.228 1.863-1.767 15.555 1.696 18.71.374.34.745.51 1.107.51.12 0 .239-.019.356-.056 1.206-.383 1.729-2.637 2.451-5.756.947-4.086 2.125-9.172 5.035-9.172l.112-.004c2.892 0 4.07 5.085 5.016 9.171.723 3.12 1.245 5.374 2.451 5.756.474.151.967-.002 1.463-.455 3.464-3.154 1.924-16.846 1.696-18.71a33.364 33.364 0 002.532-4.828h2.044a33.31 33.31 0 002.535 4.833c-.228 1.864-1.768 15.555 1.696 18.71.373.34.744.51 1.107.51.12 0 .239-.018.356-.055 1.206-.383 1.728-2.637 2.451-5.757.947-4.085 2.125-9.171 5.035-9.171l.112-.005c2.891 0 4.07 5.085 5.017 9.171.722 3.12 1.245 5.374 2.45 5.757.475.15.967-.003 1.464-.456 3.463-3.154 1.923-16.846 1.695-18.71.79-1.221 5.383-8.67 3.686-13.597zm-33.119 13.19l-.106.16.024.19c.54 4.177 1.35 15.555-1.347 18.01-.12.11-.343.287-.49.242-.659-.21-1.276-2.875-1.773-5.018-1.028-4.436-2.307-9.957-6.015-9.956l-.112.004c-3.687 0-4.966 5.521-5.994 9.957-.496 2.142-1.114 4.808-1.773 5.018-.143.047-.37-.13-.49-.24-2.696-2.456-1.887-13.833-1.348-18.01l.025-.191-.107-.16a32.947 32.947 0 01-2.37-4.425h7.613v.137c0 1.448 1.163 2.625 2.593 2.625h3.833c1.43 0 2.593-1.177 2.593-2.625v-.138h7.612a32.871 32.871 0 01-2.368 4.42zM11.75 13.657v-1.293c0-.886.712-1.607 1.588-1.607h3.832a1.6 1.6 0 011.588 1.607v1.293a1.6 1.6 0 01-1.588 1.607h-3.832a1.6 1.6 0 01-1.588-1.607zM27.798 12.5h-8.036v-.138c0-1.447-1.163-2.624-2.593-2.624h-3.832c-1.43 0-2.594 1.177-2.594 2.624v.138H2.706c-.958-2.444-1.624-5.254-.88-7.413.514-1.493 1.63-2.495 3.409-3.066 1.185-.379 2.3-.568 3.344-.568 1.287 0 2.463.288 3.516.865 3.077 1.686 4.108 5.313 4.118 5.35l.97-.272c-.026-.093-.387-1.375-1.315-2.815C17.446 2.463 20.32.433 25.27 2.017c1.78.57 2.895 1.573 3.408 3.065.745 2.161.078 4.974-.881 7.418zm1.082 0c.234-.627.444-1.273.62-1.93.175.657.385 1.303.618 1.93H28.88zm24.62 5.439l-.107.16.025.19c.54 4.176 1.349 15.554-1.348 18.01-.12.11-.342.286-.49.24-.658-.208-1.276-2.874-1.773-5.017-1.027-4.436-2.307-9.957-6.014-9.956l-.112.004c-3.687 0-4.967 5.521-5.995 9.957-.496 2.142-1.114 4.808-1.773 5.017-.143.047-.37-.13-.49-.24-2.695-2.456-1.887-13.833-1.348-18.01l.025-.191-.107-.16a32.947 32.947 0 01-2.37-4.425h7.613v.138c0 1.447 1.164 2.624 2.594 2.624h3.832c1.43 0 2.593-1.177 2.593-2.624v-.138h7.612a32.855 32.855 0 01-2.367 4.42zm-13.257-4.283v-1.293a1.6 1.6 0 011.588-1.607h3.832a1.6 1.6 0 011.588 1.607v1.293c0 .886-.712 1.607-1.588 1.607h-3.832a1.6 1.6 0 01-1.588-1.607zM56.292 12.5h-8.035v-.138c0-1.447-1.164-2.624-2.594-2.624h-3.832c-1.43 0-2.593 1.177-2.593 2.624v.138H31.2c-.958-2.444-1.624-5.254-.88-7.413.514-1.493 1.63-2.495 3.41-3.066 1.184-.379 2.3-.568 3.343-.568 1.288 0 2.463.288 3.516.865 3.078 1.686 4.108 5.313 4.118 5.35l.97-.272c-.026-.093-.386-1.374-1.315-2.815 1.578-2.118 4.454-4.15 9.403-2.564 1.78.57 2.895 1.573 3.409 3.065.745 2.161.077 4.974-.882 7.418z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  }
}

class IconDentalProsthesis extends Component<{}> {
  render() {
    return (
      <svg
        viewBox="0 0 44 41"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="#4A4A4A" transform="translate(-51 -1577)">
            <g transform="translate(18 1411)">
              <path
                d="M31.508 23.123c0 .022.002.044.004.066v.44c0 .013 0 .027.002.04.008.115.737 11.521-6.427 16.136.57-1.907.943-4.962.515-7.61-.354-2.186-1.212-4.18-2.414-5.613-1.22-1.451-2.71-2.25-4.197-2.25-1.489 0-2.979.799-4.197 2.25-1.203 1.434-2.06 3.427-2.414 5.613-.429 2.647-.055 5.702.514 7.61-3.7-2.383-5.252-6.587-5.902-9.708-.723-3.464-.526-6.4-.524-6.428V23.279a.56.56 0 00.023-.156c0-2.124-1.24-4.144-2.55-6.282-1.374-2.238-2.793-4.553-2.793-7.067 0-4.761 3.91-8.636 8.718-8.636 1.942 0 3.707.415 5.104 1.201 1.236.695 2.271 1.778 3.272 2.825.26.272.53.554.8.825l.087.088c.08.078 1.96 1.917 4.285 2.11a.574.574 0 00.62-.52.57.57 0 00-.524-.614c-1.607-.133-3.036-1.303-3.45-1.67 1.618-2.625 4.676-4.245 8.01-4.245h.06c4.809.028 8.722 3.902 8.722 8.636 0 2.514-1.42 4.829-2.793 7.067-1.312 2.138-2.55 4.158-2.55 6.282M38 9.774a9.638 9.638 0 00-2.89-6.9A9.94 9.94 0 0028.136 0c-3.652-.023-7.031 1.712-8.902 4.548a39.144 39.144 0 01-.16-.167c-1.059-1.107-2.154-2.252-3.538-3.031C13.967.467 12.007 0 9.867 0 4.425 0 0 4.386 0 9.774c0 2.832 1.504 5.285 2.96 7.657 1.19 1.944 2.318 3.781 2.38 5.542a.563.563 0 00-.02.146v.49c-.018.298-.183 3.193.541 6.69 1.003 4.836 3.255 8.476 6.512 10.527a1.109 1.109 0 001.267-.052c.372-.28.523-.748.386-1.19-.55-1.774-.92-4.69-.513-7.209.638-3.937 2.993-6.906 5.478-6.906s4.84 2.97 5.477 6.906c.408 2.52.037 5.435-.512 7.208-.137.443.013.91.385 1.19.372.282.87.303 1.267.053 3.257-2.05 5.51-5.691 6.512-10.528.725-3.496.56-6.391.54-6.689v-.49a.676.676 0 00-.003-.062c.028-1.786 1.173-3.651 2.383-5.626C36.495 15.06 38 12.606 38 9.774"
                transform="translate(33 166)"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconDental extends Component<{}> {
  render() {
    return (
      <svg

        viewBox="0 0 54 54"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(-48 -1487)">
            <g transform="translate(18 1411)">
              <g transform="translate(30 76)">
                <g fill="#4A4A4A" transform="translate(0 .415)">
                  <path d="M17.042 17.153c-3.593 3.57-9.45 3.57-13.05 0-3.6-3.569-3.6-9.376 0-12.939 3.6-3.569 9.45-3.569 13.05 0a9.025 9.025 0 012.705 6.467 9.029 9.029 0 01-2.705 6.472zm-3.674 9.968v22.215a1.76 1.76 0 01-1.763 1.747H9.43a1.76 1.76 0 01-1.763-1.747V27.121h5.702zM3.076 3.307a10.383 10.383 0 000 14.754c1.878 1.862 4.299 2.856 6.766 3.018v4.698H6.31v23.559c0 1.707 1.397 3.091 3.119 3.091h2.176c1.722 0 3.119-1.384 3.119-3.091V25.777h-3.526V21.08c2.461-.162 4.882-1.156 6.76-3.018a10.32 10.32 0 003.078-7.38c0-2.783-1.092-5.405-3.078-7.374-4.102-4.066-10.773-4.066-14.882 0z"></path>
                </g>
                <path
                  fill="#FF5A5F"
                  className="custom-fill"
                  d="M31 27h7v23a2 2 0 01-2 2h-3a2 2 0 01-2-2V27z"
                ></path>
                <path
                  fill="#4A4A4A"
                  d="M4.66718644 11.9149006L14.8373559 5.19338165 15.5892203 6.31184241 5.41905085 13.0333614z"
                ></path>
                <path
                  fill="#4A4A4A"
                  d="M8.79688136 16.400708L8.06874576 15.2667877 15.5256949 10.5610523 16.2538305 11.6949725z"
                ></path>
                <g fill="#4A4A4A" transform="translate(27.797 5.12)">
                  <path d="M5.605 8.946c-.014.03-.025-.094-.035-.262h.035v.262zm3.464 13.47v22.215c0 .961-.793 1.747-1.77 1.747H5.13c-.976 0-1.77-.786-1.77-1.747V22.416h5.71zM11.036.31h-7.56C1.652.31.175 1.775.175 3.583V5.41c0 1.808 1.477 3.273 3.301 3.273h2.061v12.254c0 .047.02.087.027.134H2.005v23.559c0 1.707 1.403 3.091 3.125 3.091H7.3c1.722 0 3.125-1.384 3.125-3.091V21.072H6.866c.007-.047.027-.087.027-.134V9.228c0-.08-.02-.154-.04-.228V7.911h-.047a.67.67 0 00-.659-.571h-2.67A1.938 1.938 0 011.53 5.41V3.584c0-1.07.875-1.93 1.946-1.93h7.56a.672.672 0 100-1.344z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconWallet extends Component<{}> {
  render() {
    return (
      <svg
        viewBox="0 0 32 24"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(-108 -2070)">
            <g transform="translate(18 1992)">
              <g transform="translate(90 78)">
                <path
                  fill="#EF8D90"
                  className="custom-fill"
                  d="M3.274 6.066h16.731V3.24H3.274c-1.056 0-2.473.397-2.473 1.414.454.873 1.417 1.412 2.473 1.412"
                ></path>
                <path
                  fill="#000"
                  d="M20.423 6.48H3.274v-.828h16.313V3.654H3.274c-.853 0-2.055.31-2.055 1H.383c0-1.256 1.498-1.828 2.891-1.828h17.15V6.48z"
                ></path>
                <path
                  fill="#000"
                  d="M20.423 6.48H3.274v-.828h16.313V3.654H3.274c-.853 0-2.055.31-2.055 1H.383c0-1.256 1.498-1.828 2.891-1.828h17.15V6.48z"
                ></path>
                <path
                  fill="#000"
                  d="M3.274 6.48C1.469 6.48 0 5.026 0 3.24 0 1.453 1.47 0 3.274 0h18.187c1.225 0 2.221.987 2.221 2.199v3.867h-.836V2.199A1.38 1.38 0 0021.46.828H3.274C1.93.828.837 1.91.837 3.24c0 1.33 1.093 2.412 2.437 2.412v.828z"
                ></path>
                <g fill="#000" transform="translate(0 3.016)">
                  <path d="M25.508 20.42H2.152C.966 20.42 0 19.463 0 18.29V.224h.836V18.29c0 .718.59 1.301 1.316 1.301h23.356a1.31 1.31 0 001.315-1.301V4.765a1.31 1.31 0 00-1.315-1.301H3.274v-.828h22.234c1.186 0 2.152.955 2.152 2.13V18.29c0 1.174-.966 2.13-2.152 2.13"></path>
                </g>
                <path
                  fill="#88E7D4"
                  className="custom-fill"
                  d="M20.782 16.527h6.658a.9.9 0 00.901-.892V12.61a.9.9 0 00-.901-.892h-6.658c-1.342 0-1.342 4.809 0 4.809"
                ></path>
                <path
                  fill="#FF5A5F"
                  className="custom-fill"
                  d="M22.41 16.527h5.03a.9.9 0 00.901-.892V12.61a.9.9 0 00-.901-.892h-6.658c-1.342 0-2.43 1.076-2.43 2.404 0 1.328 1.088 2.405 2.43 2.405h1.628z"
                ></path>
                <path
                  fill="#000"
                  d="M20.782 12.131a2.003 2.003 0 00-2.012 1.991c0 1.098.903 1.99 2.012 1.99h6.658a.482.482 0 00.483-.478V12.61a.482.482 0 00-.483-.479h-6.658zm6.658 4.81h-6.658c-1.57 0-2.848-1.265-2.848-2.819s1.277-2.818 2.848-2.818h6.658c.727 0 1.32.586 1.32 1.306v3.024c0 .72-.593 1.307-1.32 1.307z"
                ></path>
                <path
                  fill="#000"
                  d="M20.6563654 14.5362167L22.8606442 14.5362167 22.8606442 13.7084092 20.6563654 13.7084092z"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconSuitcase extends Component<{}> {
  render() {
    return (
      <svg
        viewBox="0 0 24 20"
      >
        <defs>
          <path
            id="path-1"
            d="M0.0000969387755 0.0963125L18.851102 0.0963125 18.851102 8.8329184 0.0000969387755 8.8329184z"
          ></path>
          <path
            id="path-3"
            d="M0.0838714286 0.04815625L17.604198 0.04815625 17.604198 8.78472222 0.0838714286 8.78472222z"
          ></path>
        </defs>
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="0">

          <path
            fill="#FF5A5F"
            className="custom-fill"
            d="M18.56 9.55c0 .566-.449 1.029-.998 1.029H1.29c-.549 0-.998-.463-.998-1.028V3.469c0-.565.45-1.028.998-1.028h16.273c.55 0 .998.463.998 1.028V9.55z"
          ></path>
          <g transform="translate(0 2.045)">
            <mask id="mask-2" fill="#fff">
              <use xlinkHref="#path-1"></use>
            </mask>
            <path
              fill="#000"
              d="M1.289.695a.719.719 0 00-.707.729v6.082c0 .401.317.728.707.728h16.273c.39 0 .708-.327.708-.728V1.424a.719.719 0 00-.708-.729H1.29zm16.273 8.138H1.29C.579 8.833 0 8.237 0 7.506V1.424C0 .692.578.096 1.29.096h16.273c.711 0 1.29.596 1.29 1.328v6.082c0 .731-.579 1.327-1.29 1.327z"
              mask="url(#mask-2)"
            ></path>
          </g>
          <path
            fill="#000"
            d="M6.556 2.141h5.74v-.814A.719.719 0 0011.589.6H7.263a.719.719 0 00-.707.728v.814zm6.321.6H5.974V1.326C5.974.595 6.552 0 7.263 0h4.326c.71 0 1.288.595 1.288 1.327V2.74z"
          ></path>
          <path
            fill="#FFF"
            d="M.956 10.579v7.11c0 .565.45 1.027.998 1.027h14.943c.549 0 .998-.462.998-1.028v-7.11H.956z"
          ></path>
          <g transform="translate(.582 10.23)">
            <mask id="mask-4" fill="#fff">
              <use xlinkHref="#path-3"></use>
            </mask>
            <path
              fill="#000"
              d="M.666.647v6.81c0 .402.317.729.707.729h14.942c.39 0 .708-.327.708-.729V.647H.666zm15.65 8.138H1.372c-.711 0-1.29-.596-1.29-1.328V.048h17.521v7.41c0 .731-.578 1.327-1.289 1.327z"
              mask="url(#mask-4)"
            ></path>
          </g>
          <path
            fill="#FFF"
            d="M4.51986735 11.8772839L6.23645918 11.8772839 6.23645918 9.33869878 4.51986735 9.33869878z"
          ></path>
          <path
            fill="#000"
            d="M4.81 11.578h1.136v-1.94H4.81v1.94zm-.58.599h2.297V9.039H4.23v3.138z"
          ></path>
          <path
            fill="#FFF"
            d="M12.5865306 11.8479349L14.3031224 11.8479349 14.3031224 9.30915017 12.5865306 9.30915017z"
          ></path>
          <path
            fill="#000"
            d="M12.877 11.548h1.135v-1.94h-1.135v1.94zm-.581.6h2.298V9.01h-2.298v3.137z"
          ></path>
        </g>

      </svg>
    )
  }
}

class IconCalendrier extends Component<{}> {
  render() {
    return (
      <svg
        width="130"
        height="110"
        viewBox="0 0 70 55"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(-254 -343)">
            <g transform="translate(18 241)">
              <g transform="translate(236 102)">
                <path
                  fill="#FF5A5F"
                  className="custom-fill"
                  d="M68.98 5.093a4.087 4.087 0 00-4.077-4.074H5.097A4.088 4.088 0 001.02 5.093v8.317h67.962V5.093z"
                ></path>
                <path
                  fill="#3F3F3F"
                  d="M2.039 12.392H67.96v-7.3a3.06 3.06 0 00-3.058-3.055H5.097A3.06 3.06 0 002.04 5.093v7.299zM70 14.429H0V5.093A5.1 5.1 0 015.097 0h59.806A5.1 5.1 0 0170 5.093v9.336z"
                ></path>
                <path
                  fill="#3F3F3F"
                  d="M12.9126214 17.9938272L14.9514563 17.9938272 14.9514563 8.82716049 12.9126214 8.82716049z"
                ></path>
                <path
                  fill="#3F3F3F"
                  d="M55.0485437 17.9938272L57.0873786 17.9938272 57.0873786 8.82716049 55.0485437 8.82716049z"
                ></path>
                <path
                  fill="#EF8D90"
                  className="custom-fill"
                  d="M64.9029126 53.9814815L68.9805825 53.9814815 68.9805825 49.9074074 68.9805825 42.0987654 57.0873786 53.9814815z"
                ></path>
                <path
                  fill="#3F3F3F"
                  d="M59.548 52.963h8.413v-8.406l-8.413 8.406zM70 55H54.627L70 39.64V55z"
                ></path>
                <path
                  fill="#3F3F3F"
                  d="M2.039 52.963h54.626l11.296-11.286V14.43H2.04v38.534zM57.509 55H0V12.392h70V42.52L57.51 55z"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconCake extends Component<{}> {
  render() {
    return (
      <svg

        height="70"
        viewBox="0 0 30 25"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(-33 -1392)">
            <g transform="translate(18 1325)">
              <g transform="translate(15 67.236)">
                <path
                  fill="#000"
                  d="M0 19.4803372L29.8804615 19.4803372 29.8804615 18.7943943 0 18.7943943z"
                ></path>
                <g transform="translate(3.162)">
                  <path
                    fill="#000"
                    d="M.692 18.795h22.173v-3.776c-.302.143-.66.29-1.29.29-.694 0-1.058-.177-1.379-.334-.29-.14-.54-.263-1.072-.263s-.783.122-1.073.263c-.32.157-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.14-.54-.263-1.071-.263-.532 0-.782.122-1.072.263-.32.156-.685.333-1.378.333-.693 0-1.056-.177-1.377-.333-.29-.14-.54-.263-1.072-.263s-.782.122-1.071.263c-.321.157-.685.333-1.378.333-.693 0-1.057-.176-1.378-.333-.29-.14-.54-.263-1.072-.263s-.782.122-1.072.263c-.321.157-.685.333-1.378.333-.626 0-.984-.144-1.285-.287v3.774zm22.52.685H.345A.344.344 0 010 19.137v-4.644c0-.111.054-.215.145-.28a.35.35 0 01.314-.044c.17.058.31.125.444.19.29.142.542.264 1.074.264s.783-.122 1.072-.263c.321-.156.685-.333 1.378-.333.693 0 1.057.177 1.378.333.29.14.54.263 1.072.263s.782-.122 1.072-.263c.32-.156.685-.333 1.377-.333.693 0 1.057.177 1.378.333.29.14.54.263 1.071.263.532 0 .783-.122 1.073-.263.32-.156.684-.333 1.377-.333.692 0 1.056.177 1.377.333.29.14.54.263 1.072.263s.782-.122 1.072-.263c.321-.156.685-.333 1.378-.333.693 0 1.057.177 1.378.333.29.14.54.263 1.072.263.534 0 .785-.122 1.076-.263.136-.066.277-.135.449-.193a.35.35 0 01.313.045.341.341 0 01.145.28v4.645c0 .19-.155.343-.346.343z"
                  ></path>
                  <path

                    className="custom-fill"
                    d="M.346 11.092v3.4c.51.175.764.474 1.631.474 1.225 0 1.225-.597 2.45-.597s1.225.597 2.45.597 1.225-.597 2.45-.597c1.224 0 1.224.597 2.448.597 1.225 0 1.225-.597 2.45-.597 1.224 0 1.224.597 2.449.597 1.225 0 1.225-.597 2.45-.597s1.225.597 2.45.597c.871 0 1.125-.3 1.637-.475v-3.4H.346z"
                  ></path>
                  <path
                    fill="#000"
                    d="M19.124 14.027c.693 0 1.057.176 1.378.333.29.14.54.263 1.072.263.534 0 .785-.122 1.076-.263.07-.034.14-.068.215-.101v-2.824H.692v2.826c.074.032.143.066.211.099.29.14.542.263 1.075.263.531 0 .782-.122 1.071-.263.321-.157.685-.333 1.378-.333.693 0 1.057.176 1.378.333.29.14.54.263 1.072.263s.782-.122 1.072-.263c.32-.157.685-.333 1.377-.333.693 0 1.057.176 1.378.333.29.14.54.263 1.071.263.532 0 .783-.122 1.073-.263.32-.157.684-.333 1.377-.333.692 0 1.056.176 1.377.333.29.14.54.263 1.072.263s.782-.122 1.072-.263c.321-.157.685-.333 1.378-.333m2.45 1.281c-.693 0-1.057-.177-1.378-.333-.29-.14-.54-.263-1.072-.263s-.783.122-1.072.263c-.321.156-.685.333-1.378.333-.693 0-1.057-.177-1.378-.333-.29-.14-.54-.263-1.071-.263-.532 0-.782.122-1.072.263-.32.156-.685.333-1.378.333-.692 0-1.056-.177-1.377-.333-.29-.14-.54-.263-1.072-.263s-.782.122-1.072.263c-.32.156-.684.333-1.377.333s-1.056-.177-1.377-.333c-.29-.14-.541-.263-1.073-.263-.532 0-.782.122-1.072.263-.321.156-.685.333-1.377.333-.694 0-1.058-.177-1.38-.332-.121-.06-.236-.115-.365-.16A.343.343 0 010 14.494v-3.401c0-.19.155-.343.346-.343h22.865c.191 0 .346.153.346.343v3.399a.343.343 0 01-.233.324c-.131.045-.247.1-.37.16-.321.156-.686.333-1.38.333"
                  ></path>
                  <path

                    className="custom-fill"
                    d="M10.7238 11.0917657L12.8337231 11.0917657 12.8337231 4.48422287 10.7238 4.48422287z"
                  ></path>
                  <path
                    fill="#000"
                    d="M11.07 10.749h1.418V4.827H11.07v5.922zm1.764.686h-2.11a.344.344 0 01-.346-.343V4.484c0-.189.155-.343.346-.343h2.11c.19 0 .346.154.346.343v6.608c0 .19-.155.343-.346.343z"
                  ></path>
                  <path
                    fill="#000"
                    d="M11.4322615 4.48422287L12.1245692 4.48422287 12.1245692 3.31690859 11.4322615 3.31690859z"
                  ></path>
                  <path
                    fill="#000"
                    d="M11.779.917c-.377.539-.709 1.126-.709 1.355 0 .387.318.702.708.702.391 0 .71-.315.71-.702 0-.23-.333-.816-.71-1.355m0 2.743c-.772 0-1.4-.623-1.4-1.388 0-.66.938-1.903 1.126-2.145a.36.36 0 01.549 0c.188.242 1.127 1.485 1.127 2.145 0 .765-.629 1.388-1.402 1.388"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}
class IconCake2 extends Component<{}> {
  render() {
    return (
      <svg

        height="70"
        viewBox="0 0 30 25"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(-33 -1440)">
            <g transform="translate(18 1325)">
              <g transform="translate(15 115)">
                <path
                  fill="#000"
                  d="M0 19.7161143L29.8804615 19.7161143 29.8804615 19.0301714 0 19.0301714z"
                ></path>
                <g transform="translate(3 .191)">
                  <path
                    fill="#000"
                    d="M.854 18.84h22.173v-3.777c-.302.144-.66.29-1.29.29-.694 0-1.058-.177-1.379-.333-.29-.141-.54-.263-1.072-.263s-.783.122-1.073.263c-.32.156-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.141-.54-.263-1.071-.263-.532 0-.782.122-1.072.263-.321.156-.685.333-1.378.333-.693 0-1.056-.177-1.377-.333-.29-.141-.54-.263-1.072-.263s-.782.122-1.072.263c-.32.156-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.141-.54-.263-1.072-.263s-.782.122-1.072.263c-.321.156-.685.333-1.378.333-.626 0-.984-.145-1.285-.287v3.773zm22.519.685H.508a.344.344 0 01-.346-.343v-4.645c0-.11.054-.215.145-.279a.35.35 0 01.314-.045c.17.058.309.126.444.192.29.14.542.262 1.074.262s.782-.121 1.072-.262c.321-.157.685-.334 1.378-.334.693 0 1.057.177 1.377.334.29.14.54.262 1.073.262.532 0 .782-.121 1.072-.262.32-.157.684-.334 1.377-.334s1.056.177 1.377.334c.29.14.54.262 1.072.262s.783-.121 1.073-.263c.32-.156.684-.333 1.377-.333.692 0 1.056.177 1.377.334.29.14.54.262 1.072.262s.782-.121 1.072-.262c.321-.157.685-.334 1.378-.334.693 0 1.056.177 1.377.333.29.142.541.263 1.073.263.534 0 .785-.122 1.076-.263.136-.066.277-.134.449-.193a.35.35 0 01.313.046.341.341 0 01.145.279v4.646c0 .19-.155.343-.346.343z"
                  ></path>
                  <path
                    className="custom-fill"
                    d="M.508 11.136v3.401c.509.175.764.473 1.631.473 1.225 0 1.225-.596 2.45-.596s1.225.596 2.45.596c1.224 0 1.224-.596 2.45-.596 1.224 0 1.224.596 2.448.596 1.225 0 1.225-.596 2.45-.596 1.224 0 1.224.596 2.449.596 1.225 0 1.225-.596 2.45-.596s1.225.596 2.45.596c.87 0 1.125-.3 1.637-.474v-3.4H.508z"
                  ></path>
                  <path
                    fill="#000"
                    d="M19.286 14.071c.693 0 1.056.177 1.377.333.29.141.541.263 1.073.263.534 0 .785-.122 1.076-.263.07-.033.14-.067.215-.1v-2.825H.854v2.826c.074.033.143.066.21.1.292.14.543.262 1.075.262.532 0 .782-.122 1.072-.263.321-.156.685-.333 1.377-.333.694 0 1.058.177 1.378.333.29.141.54.263 1.073.263.532 0 .782-.122 1.072-.263.32-.156.684-.333 1.377-.333s1.056.177 1.377.333c.29.141.54.263 1.072.263s.783-.122 1.073-.263c.32-.156.684-.333 1.377-.333.692 0 1.056.177 1.377.333.29.141.54.263 1.072.263s.782-.122 1.072-.263c.321-.156.685-.333 1.378-.333m2.45 1.282c-.693 0-1.057-.177-1.378-.333-.29-.141-.54-.263-1.072-.263s-.783.122-1.073.263c-.32.156-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.141-.54-.263-1.071-.263-.532 0-.782.122-1.072.263-.321.156-.685.333-1.378.333-.693 0-1.056-.177-1.377-.333-.29-.141-.54-.263-1.072-.263s-.782.122-1.072.263c-.32.156-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.141-.54-.263-1.073-.263-.531 0-.781.122-1.071.263-.321.156-.685.333-1.378.333-.693 0-1.057-.177-1.379-.333-.121-.059-.236-.115-.365-.159a.343.343 0 01-.233-.324v-3.4c0-.19.155-.343.346-.343h22.865c.191 0 .346.153.346.343v3.399a.343.343 0 01-.234.324c-.13.045-.246.1-.368.16-.322.156-.687.333-1.38.333"
                  ></path>
                  <path
                    className="custom-fill"
                    d="M7.479 11.1364571L9.58915385 11.1364571 9.58915385 4.52891429 7.479 4.52891429z"
                  ></path>
                  <path
                    fill="#000"
                    d="M7.825 10.794h1.418V4.872H7.825v5.922zm1.764.685H7.48a.344.344 0 01-.346-.343V4.53c0-.19.155-.343.346-.343h2.11c.191 0 .346.154.346.343v6.607c0 .19-.155.343-.346.343z"
                  ></path>
                  <path
                    fill="#000"
                    d="M8.18815385 4.52891429L8.88046154 4.52891429 8.88046154 3.3616 8.18815385 3.3616z"
                  ></path>
                  <path
                    fill="#000"
                    d="M8.534.962c-.377.538-.709 1.125-.709 1.354 0 .388.318.703.71.703.39 0 .708-.315.708-.703 0-.23-.332-.816-.709-1.354m0 2.743a1.396 1.396 0 01-1.401-1.389c0-.66.939-1.902 1.127-2.145a.347.347 0 01.549 0c.188.243 1.126 1.485 1.126 2.145 0 .766-.628 1.389-1.4 1.389"
                  ></path>
                  <path

                    className="custom-fill"
                    d="M13 10.6075429L15.1099231 10.6075429 15.1099231 4 13 4z"
                  ></path>
                  <path
                    fill="#000"
                    d="M13.692 10.608h1.418V4.686h-1.418v5.922zm1.764.685h-2.11A.344.344 0 0113 10.95V4.343c0-.19.155-.343.346-.343h2.11c.19 0 .346.154.346.343v6.607c0 .19-.155.343-.346.343z"
                  ></path>
                  <path
                    fill="#000"
                    d="M14 4.16731429L14.6923077 4.16731429 14.6923077 3 14 3z"
                  ></path>
                  <path
                    fill="#000"
                    d="M14.401.917c-.377.539-.709 1.126-.709 1.355 0 .387.318.702.709.702.39 0 .71-.315.71-.702 0-.23-.333-.817-.71-1.355m0 2.743A1.396 1.396 0 0113 2.272c0-.66.938-1.903 1.127-2.145a.36.36 0 01.548 0c.189.242 1.127 1.485 1.127 2.145 0 .765-.628 1.388-1.401 1.388"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconCake3 extends Component<{}> {
  render() {
    return (
      <svg
        height="70"
        viewBox="0 0 30 25"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(-33 -1489)">
            <g transform="translate(18 1325)">
              <g transform="translate(15 164)">
                <path
                  fill="#000"
                  d="M0 19.7161143L29.8804615 19.7161143 29.8804615 19.0301714 0 19.0301714z"
                ></path>
                <g transform="translate(3 .191)">
                  <path
                    fill="#000"
                    d="M.854 18.84h22.173v-3.777c-.302.144-.66.29-1.29.29-.694 0-1.058-.177-1.379-.333-.29-.141-.54-.263-1.072-.263s-.783.122-1.073.263c-.32.156-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.141-.54-.263-1.071-.263-.532 0-.782.122-1.072.263-.321.156-.685.333-1.378.333-.693 0-1.056-.177-1.377-.333-.29-.141-.54-.263-1.072-.263s-.782.122-1.072.263c-.32.156-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.141-.54-.263-1.072-.263s-.782.122-1.072.263c-.321.156-.685.333-1.378.333-.626 0-.984-.145-1.285-.287v3.773zm22.519.685H.508a.344.344 0 01-.346-.343v-4.645c0-.11.054-.215.145-.279a.35.35 0 01.314-.045c.17.058.309.126.444.192.29.14.542.262 1.074.262s.782-.121 1.072-.262c.321-.157.685-.334 1.378-.334.693 0 1.057.177 1.377.334.29.14.54.262 1.073.262.532 0 .782-.121 1.072-.262.32-.157.684-.334 1.377-.334s1.056.177 1.377.334c.29.14.54.262 1.072.262s.783-.121 1.073-.263c.32-.156.684-.333 1.377-.333.692 0 1.056.177 1.377.334.29.14.54.262 1.072.262s.782-.121 1.072-.262c.321-.157.685-.334 1.378-.334.693 0 1.056.177 1.377.333.29.142.541.263 1.073.263.534 0 .785-.122 1.076-.263.136-.066.277-.134.449-.193a.35.35 0 01.313.046.341.341 0 01.145.279v4.646c0 .19-.155.343-.346.343z"
                  ></path>
                  <path
                    className="custom-fill"
                    d="M.508 11.136v3.401c.509.175.764.473 1.631.473 1.225 0 1.225-.596 2.45-.596s1.225.596 2.45.596c1.224 0 1.224-.596 2.45-.596 1.224 0 1.224.596 2.448.596 1.225 0 1.225-.596 2.45-.596 1.224 0 1.224.596 2.449.596 1.225 0 1.225-.596 2.45-.596s1.225.596 2.45.596c.87 0 1.125-.3 1.637-.474v-3.4H.508z"
                  ></path>
                  <path
                    fill="#000"
                    d="M19.286 14.071c.693 0 1.056.177 1.377.333.29.141.541.263 1.073.263.534 0 .785-.122 1.076-.263.07-.033.14-.067.215-.1v-2.825H.854v2.826c.074.033.143.066.21.1.292.14.543.262 1.075.262.532 0 .782-.122 1.072-.263.321-.156.685-.333 1.377-.333.694 0 1.058.177 1.378.333.29.141.54.263 1.073.263.532 0 .782-.122 1.072-.263.32-.156.684-.333 1.377-.333s1.056.177 1.377.333c.29.141.54.263 1.072.263s.783-.122 1.073-.263c.32-.156.684-.333 1.377-.333.692 0 1.056.177 1.377.333.29.141.54.263 1.072.263s.782-.122 1.072-.263c.321-.156.685-.333 1.378-.333m2.45 1.282c-.693 0-1.057-.177-1.378-.333-.29-.141-.54-.263-1.072-.263s-.783.122-1.073.263c-.32.156-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.141-.54-.263-1.071-.263-.532 0-.782.122-1.072.263-.321.156-.685.333-1.378.333-.693 0-1.056-.177-1.377-.333-.29-.141-.54-.263-1.072-.263s-.782.122-1.072.263c-.32.156-.684.333-1.377.333s-1.057-.177-1.378-.333c-.29-.141-.54-.263-1.073-.263-.531 0-.781.122-1.071.263-.321.156-.685.333-1.378.333-.693 0-1.057-.177-1.379-.333-.121-.059-.236-.115-.365-.159a.343.343 0 01-.233-.324v-3.4c0-.19.155-.343.346-.343h22.865c.191 0 .346.153.346.343v3.399a.343.343 0 01-.234.324c-.13.045-.246.1-.368.16-.322.156-.687.333-1.38.333"
                  ></path>
                  <path
                    className="custom-fill"
                    d="M4.479 11.1364571L6.58915385 11.1364571 6.58915385 4.52891429 4.479 4.52891429z"
                  ></path>
                  <path
                    fill="#000"
                    d="M4.825 10.794h1.418V4.872H4.825v5.922zm1.764.685H4.48a.344.344 0 01-.346-.343V4.53c0-.19.155-.343.346-.343h2.11c.191 0 .346.154.346.343v6.607c0 .19-.155.343-.346.343z"
                  ></path>
                  <path
                    fill="#000"
                    d="M5.18815385 4.52891429L5.88046154 4.52891429 5.88046154 3.3616 5.18815385 3.3616z"
                  ></path>
                  <path
                    fill="#000"
                    d="M5.534.962c-.377.538-.709 1.125-.709 1.354 0 .388.318.703.71.703.39 0 .708-.315.708-.703 0-.23-.332-.816-.709-1.354m0 2.743a1.396 1.396 0 01-1.401-1.389c0-.66.939-1.902 1.127-2.145a.347.347 0 01.549 0c.188.243 1.126 1.485 1.126 2.145 0 .766-.628 1.389-1.4 1.389"
                  ></path>
                  <path
                    className="custom-fill"
                    d="M10.8856154 11.1364571L12.9955385 11.1364571 12.9955385 4.52891429 10.8856154 4.52891429z"
                  ></path>
                  <path
                    fill="#000"
                    d="M11.232 10.794h1.417V4.872h-1.417v5.922zm1.764.685h-2.11a.344.344 0 01-.347-.343V4.53c0-.19.156-.343.347-.343h2.11c.19 0 .346.154.346.343v6.607c0 .19-.155.343-.346.343z"
                  ></path>
                  <path
                    fill="#000"
                    d="M11.5940769 4.52891429L12.2863846 4.52891429 12.2863846 3.3616 11.5940769 3.3616z"
                  ></path>
                  <path
                    fill="#000"
                    d="M11.94.962c-.376.538-.708 1.125-.708 1.354 0 .388.318.703.708.703.391 0 .71-.315.71-.703 0-.23-.333-.816-.71-1.354m0 2.743c-.772 0-1.4-.623-1.4-1.389 0-.66.938-1.902 1.126-2.145a.36.36 0 01.549 0c.188.243 1.127 1.485 1.127 2.145 0 .766-.629 1.389-1.402 1.389"
                  ></path>
                  <path
                    fill="#EF8D90"
                    d="M17.292 11.1364571L19.4019231 11.1364571 19.4019231 4.52891429 17.292 4.52891429z"
                  ></path>
                  <path
                    fill="#000"
                    d="M17.638 10.794h1.418V4.872h-1.418v5.922zm1.764.685h-2.11a.344.344 0 01-.346-.343V4.53c0-.19.155-.343.346-.343h2.11c.191 0 .346.154.346.343v6.607c0 .19-.155.343-.346.343z"
                  ></path>
                  <path
                    fill="#000"
                    d="M18.0004615 4.52891429L18.6927692 4.52891429 18.6927692 3.3616 18.0004615 3.3616z"
                  ></path>
                  <path
                    fill="#000"
                    d="M18.347.962c-.377.539-.71 1.126-.71 1.355 0 .387.319.702.71.702.39 0 .709-.315.709-.702 0-.23-.332-.817-.71-1.355m0 2.742a1.396 1.396 0 01-1.4-1.387c0-.66.938-1.903 1.126-2.146a.36.36 0 01.549 0c.188.243 1.127 1.485 1.127 2.146 0 .765-.629 1.387-1.401 1.387"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconMan extends Component<{}> {
  render() {
    return (
      <svg
        height="100"
        viewBox="0 0 32 66"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="#E8E2E2" transform="translate(-94 -770)">
            <g transform="translate(18 697)">
              <g transform="translate(41 73)">
                <g transform="translate(35)">
                  <path className="custom-fill" d="M31.545 35.104l-4.263-16.839 2.054 8.112h-5.562l1.72 9.392.538 1.384c.573 1.473 2.294 2.232 3.804 1.671 1.514-.563 2.285-2.238 1.709-3.72M7.65 15.27l.146.014 15.714.052c1.295-.193 3.134 1.51 3.713 2.789l.059.14 2.054 8.11h-5.56l-.193-1.04.218 22.944.172 14.04c.01.68-.187 1.319-.53 1.862a3.673 3.673 0 01-3.134 1.753c-1.934 0-3.538-1.514-3.64-3.377l-.005-.187V39.182h-2.022V62.32c0 .441-.085.867-.239 1.26a3.662 3.662 0 01-3.223 2.35l-.203.006c-1.936 0-3.561-1.503-3.642-3.376l-.003-.188.165-13.331.215-22.664.01-1.046v-.052l-.155 1.098-1.325 9.34-.538 1.385C5.13 38.575 3.41 39.333 1.9 38.77c-1.514-.562-2.285-2.237-1.71-3.72l1.976-8.675 1.858-8.162c.484-1.244 2.293-3 3.626-2.943zM15.7.175c3.713 0 6.723 2.944 6.723 6.576 0 2.453-1.373 4.593-3.41 5.722a6.806 6.806 0 01-3.407.906c-3.713 0-6.723-2.945-6.723-6.576 0-2.452 1.373-4.59 3.41-5.722A6.81 6.81 0 0115.7.175z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconCouple extends Component<{}> {
  render() {
    return (
      <svg
        height="100"
        viewBox="0 0 61 68"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="#E8E2E2" transform="translate(-236 -769)">
            <g transform="translate(18 697)">
              <g transform="translate(198 72.296)">
                <g transform="translate(20)">
                  <path className="custom-fill" d="M16.236 22.494l-.445-4.833h.012l.465-.683.41-1.137c.1.008.35.033.699.067l.278.002h1.015c1.37.001 3.11.012 4.131.131 1.303-.202 3.172 1.64 3.658 2.929l.866 3.524 1.653 6.733 3.33-6.733.454-.92c.487-1.29 2.355-3.13 3.658-2.929l13.133.053c1.301-.2 3.17 1.638 3.658 2.929l.453.867 7.105 13.578c.56 1.483-.189 3.158-1.656 3.721-1.465.561-2.872-.329-3.689-1.671l-6.065-9.963 5.664 18.636-4.24.797.106 1.392.167 14.039a3.47 3.47 0 01-.516 1.862 3.536 3.536 0 01-3.04 1.754c-1.937 0-3.533-1.614-3.533-3.563V47.592h-1.962v15.43c0 .443-.082.867-.232 1.26-.495 1.37-1.806 2.357-3.323 2.357-1.94 0-3.558-1.604-3.534-3.563l.159-13.331.157-2.153-3.867-.797 5.246-18.687-5.646 9.962c-.774 1.365-2.224 2.231-3.689 1.67-.22-.084-.416-.2-.6-.328a2.854 2.854 0 01-1.429-1.555l-.522-1.384-1.853-10.438.211 22.949.167 14.039a3.46 3.46 0 01-.515 1.862 3.54 3.54 0 01-3.039 1.754c-1.937 0-3.535-1.617-3.535-3.564V39.886h-1.96v23.137c0 .441-.083.866-.232 1.26-.496 1.37-1.807 2.356-3.323 2.356-1.94 0-3.559-1.605-3.535-3.564l.16-13.331.219-23.762L6.054 36.42l-.523 1.384c-.555 1.474-2.224 2.233-3.689 1.67-1.467-.561-2.215-2.236-1.656-3.719l2.928-13.26.789-3.577c.486-1.29 2.355-3.13 3.658-2.929.976-.113 2.608-.129 3.945-.131h1.14c.463-.001.814-.004.973-.017l.02.057.045-.004.41 1.137.464.683h.014l-.44 4.78-.712 7.733 1.734 1.72 1.789-1.773-.709-7.68h.002z"></path>
                  <path className="custom-fill" d="M15.136 14.083c1.205 0 2.334-.33 3.303-.906a6.582 6.582 0 003.309-5.722c0-3.633-2.92-6.576-6.522-6.576a6.453 6.453 0 00-3.305.906 6.583 6.583 0 00-3.306 5.722c0 3.63 2.92 6.576 6.521 6.576"></path>
                  <path className="custom-fill" d="M42.94 16.74c1.206 0 2.335-.33 3.304-.906a6.584 6.584 0 003.308-5.723c0-3.632-2.92-6.576-6.521-6.576a6.453 6.453 0 00-3.305.907 6.584 6.584 0 00-3.307 5.722c0 3.632 2.92 6.575 6.522 6.575"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconChild extends Component<{}> {
  render() {
    return (
      <svg

        height="100"
        viewBox="0 0 56 69"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="#E8E2E2" transform="translate(-239 -922)">
            <g transform="translate(18 697)">
              <g transform="translate(182 225)">
                <g transform="translate(39)">
                  <g transform="translate(.182 .39)">
                    <path className="custom-fill" d="M25.804 46.494l-.088.242h9.279l3.67 9.827-3.513.327v8.564c0 1.142-.948 2.076-2.103 2.076-1.103 0-2.021-.855-2.1-1.929l-.005-.147V56.89h-1.179v8.564c0 1.137-.951 2.076-2.104 2.076-1.104 0-2.02-.855-2.098-1.929l-.006-.147V56.89l-3.513-.327 3.76-10.069zm1.496-6.193l.152.03 5.85-.01c.691-.136 1.433.015 1.975.587l.121.139 4.548 5.688 1.447 1.809c1.622 2.029-1.067 4.366-2.951 2.135l-3.333-3.944-.205-.242.09.242h-9.278l.09-.242-.002.001-.202.241H25.6l-3.333 3.944c-1.883 2.23-4.573-.105-2.95-2.135l1.445-1.81 4.548-5.687c.524-.653 1.278-.863 1.99-.746zM47.238.686c4.247 0 7.152 2.487 7.152 7.514-.001 4.787-2.634 9.673-6.551 10.13-1.985 4.37-1.487 7.741-.855 10.99l.12.608.043.218.085.437c.947 4.875 1.52 9.733-5.962 17.489l-.388-.365c7.627-7.904 6.675-12.714 5.696-17.678l-.124-.63c-.635-3.262-1.136-6.647.784-11.034-4.247 0-7.152-5.137-7.152-10.165 0-5.027 2.905-7.514 7.152-7.514zM30.375 29.891c2.612 0 4.73 2.09 4.73 4.667 0 2.578-2.118 4.666-4.73 4.666-2.612 0-4.729-2.088-4.729-4.666 0-2.578 2.117-4.667 4.73-4.667z"></path>
                    <text
                      fontFamily="HelveticaNeue-CondensedBlack, Helvetica Neue"
                      fontSize="23.4"
                      fontStyle="condensed"
                      fontWeight="700"
                    >
                      <tspan className="custom-fill" x="0.818" y="54.82">
                        +
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

class IconFamily extends Component<{}> {
  render() {
    return (
      <svg
        height="100"
        viewBox="0 0 87 68"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="#E8E2E2" transform="translate(-71 -922)">
            <g transform="translate(18 697)">
              <g transform="translate(36 225)">
                <g transform="translate(17)">
                  <path className="custom-fill" d="M46.098 38.602a4.837 4.837 0 004.838-4.835 4.837 4.837 0 00-4.838-4.835 4.836 4.836 0 100 9.67"></path>
                  <path className="custom-fill" d="M18.247 16.384a6.766 6.766 0 003.443-.935 6.787 6.787 0 003.448-5.911A6.796 6.796 0 0014.896 3.68a6.791 6.791 0 003.35 12.703"></path>
                  <path className="custom-fill" d="M70.618 13.64a6.766 6.766 0 003.443-.935 6.787 6.787 0 003.448-5.912A6.795 6.795 0 0067.267.936a6.79 6.79 0 00-3.446 5.912 6.795 6.795 0 006.797 6.792"></path>
                  <path className="custom-fill" d="M86.728 36.083L82.42 18.688c-.508-1.332-2.456-3.232-3.814-3.025-1.452-.167-4.296-.128-5.653-.136a40.255 40.255 0 00-.729-.07l-.427 1.174-.483.706H71.3l1.2 12.926-1.863 1.831-1.808-1.776 1.2-12.927h-.013l-.484-.706-.428-1.174-.046.004-.022-.058c-.661.052-4.534-.053-6.314.152-1.356-.208-3.305 1.693-3.812 3.026l-3.875 17.393c-.06.156-.095.315-.126.473-1.936 1.081-3.867 2.148-5.786 3.232l-.03.006-3.034.006-3.032-.006-.033-.006c-2.06-1.165-4.135-2.309-6.216-3.474l-7.827-14.826c-.508-1.332-2.456-3.233-3.814-3.026l-13.687-.054c-1.356-.207-3.305 1.693-3.812 3.025L.194 36.303a2.99 2.99 0 001.726 3.842c1.527.581 3.039-.315 3.845-1.725l5.885-10.293-5.468 19.306 4.03.823-.163 2.224-.167 13.772c-.025 2.024 1.663 3.68 3.684 3.68h.001c1.58 0 2.947-1.018 3.463-2.434.156-.406.241-.844.241-1.3V48.256h2.045v15.996c0 2.013 1.665 3.68 3.683 3.68a3.695 3.695 0 003.169-1.81c.348-.562.545-1.22.537-1.924l-.176-14.504-.108-1.438 4.42-.823-5.904-19.251 6.32 10.292c.85 1.386 2.318 2.305 3.845 1.726l.008-.005 6.296 3.57-.237 22.017c0 1.183.97 2.15 2.152 2.15 1.18 0 2.153-.974 2.153-2.15V53.065h1.207v12.717c0 1.183.975 2.15 2.151 2.15 1.183 0 2.169-.967 2.153-2.15l-.272-22.017 6.607-3.745c1.37.23 2.778-.535 3.287-1.875l.544-1.429 1.498-10.784-.23 24.548-.165 13.772c-.026 2.024 1.662 3.68 3.683 3.68a3.708 3.708 0 003.464-2.434 3.64 3.64 0 00.241-1.3V40.295h2.045v23.956c0 2.01 1.665 3.68 3.683 3.68a3.693 3.693 0 003.168-1.81c.347-.562.546-1.22.538-1.925L78.9 49.694l-.219-23.707 1.93 10.784.545 1.429c.578 1.522 2.318 2.305 3.845 1.726a2.989 2.989 0 001.727-3.843"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

/*
class Icon extends Component<{}> {
    render() {
        return ()
    }
}
*/

const icons = {
  iconBed: IconBed,
  iconStethoscope: IconStethoscope,
  iconMedicalFolder: IconMedicalFolder,
  iconDrug: IconDrug,
  iconNurse: IconNurse,
  iconHospital: IconHospital,
  iconLentils: IconLentils,
  iconGlasses: IconGlasses,
  iconRimlessGlasses: IconRimlessGlasses,
  iconOrthodontics: IconOrthodontics,
  iconDentalProsthesis: IconDentalProsthesis,
  iconDental: IconDental,
  iconWallet: IconWallet,
  iconSuitcase: IconSuitcase,
  iconCalendrier: IconCalendrier,
  iconCake: IconCake,
  iconCake2: IconCake2,
  iconCake3: IconCake3,
  iconMan: IconMan,
  iconCouple: IconCouple,
  iconChild: IconChild,
  iconFamily: IconFamily,


}
export { icons };
